import React from 'react'
import Svg from '../Svg'

import {noop} from '../../utils'
import chevronRightThick from '../../../../svg/chevron-right-thick.svg'
import chevronLeftThick from '../../../../svg/chevron-left-thick.svg'

export default {
  renderCenterLeftControls: (
    {previousSlide}, // eslint-disable-line react/prop-types
  ) => (
    <button className="outfit-items-arrow outfit-left-arrow" onClick={previousSlide}>
      <Svg className="product-carousel-arrow product-carousel-left-arrow" src={chevronLeftThick} />
    </button>
  ),
  renderCenterRightControls: (
    {nextSlide}, // eslint-disable-line react/prop-types
  ) => (
    <button className="outfit-items-arrow outfit-right-arrow" onClick={nextSlide}>
      <Svg className="product-carousel-arrow" src={chevronRightThick} />
    </button>
  ),
  renderBottomCenterControls: noop,
}
